import {
  H_07,
  HERO_DEFAULTS,
  hideH07Props,
} from "@stadium/shared/src/helpers/plasmic/static-slices";
import {
  URL_TYPE_OPTIONS,
  CATEGORY_HOME_LINK_TYPE,
  CATEGORY_PRODUCT_LISTING_LINK_TYPE,
  OTHER_LINK_TYPE,
  CATALOG_HOME_LINK_TYPE,
  EXTERNAL_LINK_TYPE,
} from "@stadium/shared/src/constants/stores/routes";

export const H07_PLASMIC_PROPS = {
  h07Heading: {
    type: "string",
    defaultValue: HERO_DEFAULTS[H_07].heading,
    description: "Main hero heading (H07 only)",
    hidden: hideH07Props,
  },
  h07Description: {
    type: "string",
    defaultValue: HERO_DEFAULTS[H_07].description,
    description: "Hero description text (H07 only)",
    hidden: hideH07Props,
  },
  h07PrimaryButtonText: {
    type: "string",
    defaultValue: HERO_DEFAULTS[H_07].primaryButtonText,
    description: "Primary button text (H07 only)",
    hidden: hideH07Props,
  },
  h07PrimaryButtonLinkType: {
    type: "choice",
    options: URL_TYPE_OPTIONS,
    defaultValue: CATALOG_HOME_LINK_TYPE,
    description: "Primary button link type (H07 only)",
    hidden: hideH07Props,
  },
  h07PrimaryButtonOtherUrl: {
    type: "string",
    defaultValue: "",
    hidden: (props) =>
      hideH07Props(props) ||
      (props.h07PrimaryButtonLinkType !== OTHER_LINK_TYPE &&
        props.h07PrimaryButtonLinkType !== EXTERNAL_LINK_TYPE),
  },
  h07PrimaryButtonOpenInNewTab: {
    type: "boolean",
    defaultValue: false,
    description: "Open primary button in new tab (H07 only)",
    hidden: hideH07Props,
  },
  h07PrimaryButtonCategorySlug: {
    type: "string",
    defaultValue: "",
    hidden: (props) =>
      hideH07Props(props) ||
      (props.h07PrimaryButtonLinkType !== CATEGORY_HOME_LINK_TYPE &&
        props.h07PrimaryButtonLinkType !== CATEGORY_PRODUCT_LISTING_LINK_TYPE),
  },
  h07SecondaryButtonText: {
    type: "string",
    defaultValue: HERO_DEFAULTS[H_07].secondaryButtonText,
    description: "Secondary button text (H07 only)",
    hidden: hideH07Props,
  },
  h07SecondaryButtonLinkType: {
    type: "choice",
    options: URL_TYPE_OPTIONS,
    defaultValue: CATALOG_HOME_LINK_TYPE,
    description: "Secondary button link type (H07 only)",
    hidden: hideH07Props,
  },
  h07SecondaryButtonOpenInNewTab: {
    type: "boolean",
    defaultValue: false,
    description: "Open secondary button in new tab (H07 only)",
    hidden: hideH07Props,
  },
  h07SecondaryButtonOtherUrl: {
    type: "string",
    defaultValue: "",
    hidden: (props) =>
      hideH07Props(props) ||
      (props.h07SecondaryButtonLinkType !== OTHER_LINK_TYPE &&
        props.h07SecondaryButtonLinkType !== EXTERNAL_LINK_TYPE),
  },
  h07SecondaryButtonCategorySlug: {
    type: "string",
    defaultValue: "",
    hidden: (props) =>
      hideH07Props(props) ||
      (props.h07SecondaryButtonLinkType !== CATEGORY_HOME_LINK_TYPE &&
        props.h07SecondaryButtonLinkType !== CATEGORY_PRODUCT_LISTING_LINK_TYPE),
  },

  // Button width props for H07

  h07PrimaryButtonWidth: {
    type: "string",
    defaultValue: HERO_DEFAULTS[H_07].primaryButtonWidth,
    description: "Primary button width (e.g., 'auto' or in rem (1rem = 16px)) (H07 only)",
    hidden: hideH07Props,
  },
  h07SecondaryButtonWidth: {
    type: "string",
    defaultValue: HERO_DEFAULTS[H_07].secondaryButtonWidth,
    description: "Secondary button width ((e.g., 'auto' or in rem (1rem = 16px)) (H07 only)",
    hidden: hideH07Props,
  },

  h07HeroImage: {
    type: "imageUrl",
    defaultValue: HERO_DEFAULTS[H_07].heroImage,
    description: "Hero image (H07 only)",
    hidden: hideH07Props,
  },
  h07HeroImageAlt: {
    type: "string",
    defaultValue: HERO_DEFAULTS[H_07].heroImageAlt,
    description: "Hero image alt text (H07 only)",
    hidden: hideH07Props,
  },
  h07ShowReviewBadge: {
    type: "boolean",
    defaultValue: HERO_DEFAULTS[H_07].showReviewBadge,
    description: "Show G2 review badge (H07 only)",
    hidden: hideH07Props,
  },
  h07ReviewBadgeLogo: {
    type: "imageUrl",
    defaultValue: HERO_DEFAULTS[H_07].reviewBadgeLogo,
    description: "Review badge logo (e.g., G2) (H07 only)",
    hidden: hideH07Props,
  },
  h07ReviewBadgeLogoAlt: {
    type: "string",
    defaultValue: HERO_DEFAULTS[H_07].reviewBadgeLogoAlt,
    description: "Review badge logo alt text (H07 only)",
    hidden: hideH07Props,
  },
  h07ReviewRating: {
    type: "string",
    defaultValue: HERO_DEFAULTS[H_07].reviewRating,
    description: "Review rating score (H07 only)",
    hidden: hideH07Props,
  },
  h07ReviewCount: {
    type: "string",
    defaultValue: HERO_DEFAULTS[H_07].reviewCount,
    description: "Number of reviews (H07 only)",
    hidden: hideH07Props,
  },
  h07ReviewStarIcon: {
    type: "imageUrl",
    defaultValue: HERO_DEFAULTS[H_07].reviewStarIcon,
    description: "Star icon for rating (H07 only)",
    hidden: hideH07Props,
  },
  h07ShowLogoStrip: {
    type: "boolean",
    defaultValue: HERO_DEFAULTS[H_07].showLogoStrip,
    description: "Show logo strip section below hero (H07 only)",
    hidden: hideH07Props,
  },
  h07LogoStripEyebrow: {
    type: "string",
    defaultValue: HERO_DEFAULTS[H_07].logoStripEyebrow,
    description: "Logo strip eyebrow text (H07 only)",
    hidden: hideH07Props,
  },
  h07LogoStripHeading: {
    type: "string",
    defaultValue: HERO_DEFAULTS[H_07].logoStripHeading,
    description: "Logo strip heading (H07 only)",
    hidden: hideH07Props,
  },
  h07CompanyLogo1: {
    type: "imageUrl",
    defaultValue: HERO_DEFAULTS[H_07].companyLogo1,
    description: "Company logo 1 (H07 only)",
    hidden: hideH07Props,
  },
  h07CompanyLogo1Alt: {
    type: "string",
    defaultValue: HERO_DEFAULTS[H_07].companyLogo1Alt,
    description: "Company logo 1 alt text (H07 only)",
    hidden: hideH07Props,
  },
  h07CompanyLogo2: {
    type: "imageUrl",
    defaultValue: HERO_DEFAULTS[H_07].companyLogo2,
    description: "Company logo 2 (H07 only)",
    hidden: hideH07Props,
  },
  h07CompanyLogo2Alt: {
    type: "string",
    defaultValue: HERO_DEFAULTS[H_07].companyLogo2Alt,
    description: "Company logo 2 alt text (H07 only)",
    hidden: hideH07Props,
  },
  h07CompanyLogo3: {
    type: "imageUrl",
    defaultValue: HERO_DEFAULTS[H_07].companyLogo3,
    description: "Company logo 3 (H07 only)",
    hidden: hideH07Props,
  },
  h07CompanyLogo3Alt: {
    type: "string",
    defaultValue: HERO_DEFAULTS[H_07].companyLogo3Alt,
    description: "Company logo 3 alt text (H07 only)",
    hidden: hideH07Props,
  },
};
